import React, { useState, useEffect } from 'react'
import cx from 'classnames'
import 'react-input-range/lib/css/index.css'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styles from './MonthPicker.scss'
import { endOfMonth } from 'date-fns'

const calendarIcon = require('./assets/calendar.svg')

interface MinMaxValues {
  start?: {
    min?: Date
    max?: Date
  }
  end?: {
    min?: Date
    max?: Date
  }
}

interface MonthPickerProps {
  start: Date | string
  end: Date | string
  onChange: (value: { startDate: Date; endDate: Date; fieldChanged: 'startDate' | 'endDate' }) => void
  isNFT?: boolean
  isCharts?: boolean
  format?: string
  popperPlacement?: string
  iconUrl?: string
  containerClassName?: string
  iconClassName?: string
  showYearPicker?: boolean
  minMaxValues?: MinMaxValues
}

export default function MonthPicker({
  start,
  end,
  onChange,
  isNFT = false,
  isCharts = false,
  format = 'MMM yyyy',
  popperPlacement = 'bottom-start',
  iconUrl,
  containerClassName,
  iconClassName,
  showYearPicker,
  minMaxValues,
}: MonthPickerProps) {
  const [startDate, setStartDate] = useState<Date>(new Date(start))
  const [endDate, setEndDate] = useState<Date>(new Date(end))

  useEffect(() => {
    setEndDate(endOfMonth(new Date(end)))
  }, [end])

  useEffect(() => {
    setStartDate(new Date(start))
  }, [start])

  return (
    <div
      className={cx(
        styles.container,
        { [styles.NFTVersion]: isNFT, [styles.chartsVersion]: isCharts },
        containerClassName,
      )}
    >
      <img src={iconUrl || calendarIcon} className={cx(styles.calendarIcon, iconClassName)} alt='calendar' />
      <DatePicker
        selected={startDate}
        onChange={(date: Date | null) => {
          if (date) {
            setStartDate(date)
            onChange({ startDate: date, endDate, fieldChanged: 'startDate' })
          }
        }}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        dateFormat={format}
        showMonthYearPicker={!showYearPicker}
        showYearPicker={showYearPicker}
        popperPlacement={popperPlacement as any}
        minDate={minMaxValues?.start?.min}
        maxDate={minMaxValues?.start?.max}
      />
      <span className={styles.separator}>-</span>
      <DatePicker
        selected={endDate}
        onChange={(date: Date | null) => {
          if (date) {
            const newEndDate = endOfMonth(new Date(date))
            setEndDate(newEndDate)
            onChange({ startDate, endDate: newEndDate, fieldChanged: 'endDate' })
          }
        }}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        dateFormat={format}
        showMonthYearPicker={!showYearPicker}
        showYearPicker={showYearPicker}
        popperPlacement={popperPlacement as any}
        minDate={minMaxValues?.end?.min}
        maxDate={minMaxValues?.end?.max}
      />
    </div>
  )
}

